import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';
import type { ProviderDemand, RangeDays } from '../lib/analytics';

/**
 * Supplier analytics: this supplier's own results on the orders it was in the running for,
 * and the network's hot models with its position on each. One membership-checked SQL call.
 */
export const useProviderDemand = (providerId: string | null, days: RangeDays) => {
  const [data, setData] = useState<ProviderDemand | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    setData(null);
    setError(null);
    if (!providerId) return;

    supabase
      .rpc('get_provider_demand', { p_provider_id: providerId, p_days: days })
      .then(({ data: result, error: err }) => {
        if (cancelled) return;
        if (err) setError(err.message || 'Failed to load analytics');
        else setData(result as ProviderDemand);
      });

    return () => {
      cancelled = true;
    };
  }, [providerId, days]);

  return { data, error };
};
